import React from "react";

interface IProps {
  thProps: any;
}
//title={props.thProps.children[0]}
export const CustomHeaderCell = (props: IProps) => {  
  return <a {...props.thProps} className="font-weight-bold" />;
};
